import { MUSCLE_GROUPS } from '../../../data/constants';
import SetsEditor from './SetsEditor';

function calcEpley1RM(reps, weight) {
    const r = +reps, w = +weight;
    if (!r || !w || r > 30 || r < 1) return null;
    return Math.round(w * (1 + r / 30));
}

function getLastExerciseSets(exerciseName, records) {
    if (!exerciseName?.trim()) return null;
    const name = exerciseName.trim().toLowerCase();
    for (const rec of [...records].sort((a, b) => new Date(b.date) - new Date(a.date))) {
        if (rec.sport !== 'weight') continue;
        const exList = rec.exercises?.length
            ? rec.exercises
            : (rec.exerciseName ? [{ name: rec.exerciseName, sets: rec.sets || [] }] : []);
        const found = exList.find(ex => ex.name?.trim().toLowerCase() === name);
        if (found?.sets?.length) return { sets: found.sets, date: rec.date };
    }
    return null;
}

export default function ExercisesEditor({ exercises, onChange, records }) {
    const updateField = (i, key, val) =>
        onChange(exercises.map((ex, idx) => idx === i ? { ...ex, [key]: val } : ex));
    const updateSets = (i, sets) =>
        onChange(exercises.map((ex, idx) => idx === i ? { ...ex, sets } : ex));
    const addExercise = () =>
        onChange([...exercises, { name: '', muscleGroup: '', sets: [{ reps: '', weight: '' }] }]);
    const removeExercise = i =>
        onChange(exercises.filter((_, idx) => idx !== i));

    return (
        <>
            {exercises.map((ex, i) => (
                <div key={i} style={{ marginBottom: 16, padding: '12px 14px', background: 'var(--bg2)', borderRadius: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                        <span style={{ fontSize: 12, color: 'var(--text3)', minWidth: 20 }}>#{i + 1}</span>
                        <input
                            className="form-input"
                            style={{ flex: 1 }}
                            placeholder="운동명 (예: 랫풀다운)"
                            value={ex.name}
                            onChange={e => updateField(i, 'name', e.target.value)}
                        />
                        {exercises.length > 1 && (
                            <button className="remove-btn" onClick={() => removeExercise(i)}>×</button>
                        )}
                    </div>
                    {(() => {
                        const prev = getLastExerciseSets(ex.name, records || []);
                        if (!prev) return null;
                        const prevBest = prev.sets.reduce((max, s) => {
                            const e = calcEpley1RM(s.reps, s.weight);
                            return e && e > max ? e : max;
                        }, 0);
                        const currBest = ex.sets.reduce((max, s) => {
                            const e = calcEpley1RM(s.reps, s.weight);
                            return e && e > max ? e : max;
                        }, 0);
                        const diff = currBest && prevBest ? Math.round(currBest - prevBest) : null;
                        return (
                            <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 6, fontFamily: 'DM Mono,monospace' }}>
                                지난번 ({prev.date}): {prev.sets.slice(0, 3).map(s => `${s.reps}×${s.weight}kg`).join(' / ')}
                                {diff !== null && diff !== 0 && (
                                    <span style={{ color: diff > 0 ? '#4caf50' : '#ff7c5c', marginLeft: 6 }}>
                                        {diff > 0 ? `+${diff}` : diff}kg 1RM
                                    </span>
                                )}
                            </div>
                        );
                    })()}
                    <select
                        className="form-input"
                        style={{ marginBottom: 10, color: ex.muscleGroup ? 'var(--text1)' : 'var(--text3)' }}
                        value={ex.muscleGroup || ''}
                        onChange={e => updateField(i, 'muscleGroup', e.target.value)}
                    >
                        <option value="">운동 부위 선택</option>
                        {MUSCLE_GROUPS.map(m => <option key={m} value={m}>{m}</option>)}
                    </select>
                    <SetsEditor sets={ex.sets} onChange={sets => updateSets(i, sets)} />
                </div>
            ))}
            <button className="add-set-btn" style={{ width: '100%' }} onClick={addExercise}>+ 운동 추가</button>
        </>
    );
}
